module.exports = __webpack_public_path__ + "img/GB-SCT.c305c344.svg";